/**
 * @fileoverview One group of photos: the pictures, one question, and what follows from
 * the answer.
 *
 * The strip of photographs leads, with when they were taken. Under it,
 * "What is this?", the Location, and the Plant: one list that answers the
 * question in one pick. It holds the plants already growing in that
 * location first ("Growing in My Garden"), then every plant Grow knows as
 * a new one, by kind ("New plant: Vegetables" and the rest). A search box
 * above it narrows both, and lists what it finds under itself to tap: the
 * plants growing there, then crops, types and varieties as a new plant
 * (PlantSearchField, as when adding a plant). The server decides the list
 * and what each drop-down keeps (B121, usePlantSearch with the bed: GET
 * /plants/search); the card draws it as sent and matches nothing. It used to
 * be two questions: a Plant list of what was growing there and "Something
 * new", which then opened a second New plant list; with little growing
 * there, the first list was nearly empty and the step only confused.
 *
 * Grow's guess, where there is one, is chosen already and says so: a plant
 * of that kind growing there, or else a new one of it. A new plant's Type
 * and Variety follow only when they have a choice to offer. Stage sits
 * under them, filled in from the plant, and optional as it is when adding a
 * plant ("Not sure yet" saves the photos without one); the button says
 * what it will do:
 * "Save 2 photos to Sweet Basil", or "Add Round Radish".
 *
 * The strip of photographs is PhotoStrip, and the line under it (when, how many, the ⋯) is PileHeader. Touching a photograph opens the sheet where it is moved or given its own
 * group. Its × removes it, and the group's ⋯ removes all of it (the page
 * asks first). Cancel, beside every Add button (AddCancelRow), does what the ×
 * does for one photo and what the ⋯ does for a group (B107). A removed photo is gone at once (the page
 * says so in a short toast, with no Undo: once removed, it is removed, B45).
 *
 * A photo of seed packets asks no question: the card lists the packets read
 * off it, to tick and add to a bed in one go (PacketPile). Nor does a photo
 * of several kinds of plant (a tray of seedlings, a bouquet, a harvest, a
 * mixed bed): the card lists the plants seen, a plant for each (KindsPile),
 * with "Just one plant" to ask the question. A tray of one kind of seedling
 * is this card, at the seedling stage the guess gave it.
 *
 * A plant Grow does not have at all ("tomatillo") is offered as a new plant
 * of the gardener's own, by its name, first in the Plant list ("New to
 * Grow"): adding it makes it theirs, cared for like the plant it grows most
 * like, for Grow to review. A plant tag in the photo ("Cherokee Purple")
 * names the variety, as a flower's name does.
 *
 * A flower Grow has no group for is guessed as the broad parent it goes
 * under (Tender Annual Flower), with what Grow saw: the card says "Looks like
 * zinnias, 80% sure" rather than the parent's name, and adding it makes it
 * the gardener's own variety "Zinnia" under that parent (or the one they
 * have by that name), as a seed packet of zinnias would be: "Add Zinnia".
 * Choosing a variety, or another plant, files that instead. The Variety list
 * always shows what will be filed (2026-10-07): a name Grow saw that is not
 * one of the type's varieties is in it and chosen, "Zinnia (what Grow saw)"
 * or a tag's "Farao F1 (from the tag)", and "Not sure" files no variety
 * ("Add Cabbage"). The list and the button never disagree.
 *
 * Either way, a plant Grow does not have or a flower under a broad parent,
 * the card says plainly what Grow thinks it is, above the fields, with one
 * Yes that adds it as the button below would (2026-10-10, UnknownPlantCard:
 * "Grow thinks this is zinnia (Zinnia elegans), a tender annual flower in
 * the aster family. File it under Tender annual flower?"), the botanical
 * name and family from the guess. A plant search that finds nothing offers
 * "Not in Grow's list? Describe it" (DescribePlant), which sets the Plant
 * list to what Grow files it as.
 *
 * Every photo is guessed (2026-10-06). The group is named by its most
 * confident photo and its stage is its newest photo's, so a seedling photo
 * beside a mature one is named by the mature one. When Grow thinks a group
 * from another day is the same plant, one quiet line asks: "Same butternut
 * as your Jun 12 photos? · Yes, one plant", which puts the two groups
 * together as one plant; left alone, they stay two.
 *
 * The card draws what the server decided (audit batch 6a, A34): the pile's
 * guess, its day, and its pick (services/tray/pilePick: the type and crop
 * Grow guessed, the variety it starts on, the variety name Grow saw and
 * which types have it, the plant of that type growing in each bed, a plant
 * Grow does not have, and "Grow thinks this is …"). What the gardener then
 * picks, types and chooses is the card's own. A plant growing there is named
 * as the server titles it (lib/plantName plantTitle; audit A36): two of one
 * name in the bed are told apart by the day each was added, never "no. 2".
 *
 * A photo of seed packets the reader misread (it is plants) is asked about as
 * a plant from the group's ⋯ menu, "Ask about it as a plant" (D78 rev 2 §4:
 * "These aren't seed packets" is gone from the card's face). The Location list
 * ends with "A new bed…" and its name box (D78 P4): the plant is made in a new
 * bed by that name, with the first photo as the bed's cover; added from Beds'
 * photo row (newBed) the card starts on it.
 *
 * Where: TrayPiles (the Photos page and "Check and save"), one per pile.
 * API: none of its own; the plant picker (W24 Job B: the crops answer for the
 * Plant list, GET /plants/picker/crops, drawn as sent without its "What you grow"
 * group, since the card lists the bed's own plants; a new plant's crop starts
 * where the types answer's `start` says, Grow's guessed type first; the Type and
 * Variety lists are PlantIdentityFields'), the search (usePlantSearch: GET /plants/search, with
 * the bed; how many rows it lists is the server's Grow setting
 * plants.SEARCH_RESULTS_MAX) and the page's callbacks; DescribePlant's POST
 * /plants/identify and POST /plants/own. A failed search says the standard
 * sentence under the box (ServerFailureNote, reported to Sentry).
 * Words (en/es): tray.pile.* (whatIsThis, looking, plant, searchPlants,
 * growingIn, newOf, sameAs, sameAsYes, looksLike, looksLikePlain,
 * ourGuess, ourGuessPlain, seenOnTag, seenByGrow, missingPlant, addPhotos,
 * addNamed, addToGarden, saveTo, saveToOne, photos, photosOne, undated,
 * undo, removePhoto, removeGroup,
 * groupMenu, photoOptions, askAsPlant), tray.kinds.newToGrow, packets.newBed,
 * packets.bedName, packets.why.bed,
 * tray.kinds.newPlantNoteOne, plants.form.* (location, pickLocation,
 * loadingCatalogue, kinds.<kind>, fields.*, missing.location),
 * plants.stage.label; unknown.* (UnknownPlantCard's and DescribePlant's).
 * Watch out: the Variety list always shows what will be filed (2026-10-07):
 * a name Grow saw that is not one of the type's varieties is offered in it
 * and chosen, so the list and the button never disagree.
 *
 * The seed-packet card's Cancel keeps the photo (B137 F1, F6): in "Check and save" it closes the sheet (onKeepPhoto);
 * on the Photos page it closes the packet card back to its photo, and "Show the seed packets" brings it back.
 * The kinds card's and the plant card's Cancel do the same (B137 F1b; the way back is "Show this card").
 * Words (en/es) added: tray.pile.keptOnPage, tray.pile.packetsShow, tray.pile.cardShow.
 *
 * @module PileCard
 */

import React from 'react';
import { Button } from '@/shared/components/ui/button';
import { NativeSelect } from '@/shared/components/ui/native-select';
import Spinner from '@/shared/components/ui/Spinner';
import { GrowLoader } from '@/shared/components/ui/GrowLoader';
import { PlantIdentityFields } from '@/shared/components/plant-fields/PlantIdentityFields';
import { NoPlantFound, PlantSearchField, type PlantSearchOption } from '@/shared/components/plant-fields/PlantSearchField';
import {
  EMPTY_CHOICE, missingField, usePickStarts, usePickerCrops, useTypeVarieties, type CropChoice,
} from '@/shared/components/plant-fields/usePlantPicker';
import { usePlantSearch } from '@/shared/components/plant-fields/usePlantSearch';
import { ServerFailureNote } from '@/shared/components/ServerFailure';
import { useTranslation } from '@/shared/hooks/useTranslation';
import { cn } from '@/lib/utils';
import type { BedName } from '@/shared/api/locations';
import type { Plant } from '@/shared/types/plant';
import type { Stage } from '@/shared/types/stage';
import type { DrawnPile } from '../lib/useTray';
import type { NewBedRequest, NewPlantRequest, TrayPhoto, TypeUnsureRequest } from '@/shared/api/tray';
import { Input } from '@/shared/components/ui/input';
import { useGrowLimits } from '@/shared/lib/growSettings';
import type { KeepResult, PacketResult, PacketScan } from '@/shared/api/packets';
import { PacketPile } from './PacketPile';
import { UnknownPlantCard } from '@/shared/components/plant-fields/UnknownPlantCard';
import { DescribePlant } from '@/shared/components/plant-fields/DescribePlant';
import { KindsPile } from './KindsPile';
import { AddCancelRow } from './AddCancelRow';
import { PhotoStrip } from './PhotoStrip';
import { PileHeader } from './PileHeader';
import { plantTitle } from '@/shared/lib/plantName';

/** One group of photos, and what the gardener can do with it. */
interface PileCardProps {
  /** The group, as drawn (removed photos are not in it), with the server's guess, day and pick. */
  pile: DrawnPile;
  /** The garden's live plants, in every location. */
  gardenPlants: Plant[];
  /** The live locations, for where the photos were taken. */
  locations: BedName[];
  /** The stages a photo can show. */
  stages: Stage[];
  /** True while the model is being asked about this pile. */
  guessing: boolean;
  /** True while one of this pile's answers is being saved. */
  busy: boolean;
  /**
   * Makes a new plant with these photos on it; the stage is null when the
   * gardener is not sure yet. newVariety names a variety of their own to file
   * it as (a flower Grow saw, "Zinnia"; a tag's "Cherokee Purple"), in place of
   * varietyId. plantId is a plant Grow does not have ({ name, likePlantId })
   * when the gardener files it as their own, or a crop with Type "Not sure"
   * ({ cropId, typeUnsure: true }, B52), which the server files on the crop's usual type.
   */
  onAddNew: (plantId: number | NewPlantRequest | TypeUnsureRequest, varietyId: number | null, locationId: number | NewBedRequest, stageId: number | null, newVariety: string | null) => void;
  /** Saves these photos to a plant already in the garden; the stage is null when the gardener is not sure. */
  onAddToExisting: (plantObjId: number, stageId: number | null) => void;
  /** There is somewhere else a photo could go, so each one can be tapped to move it. */
  canMove: boolean;
  /** Opens the sheet for one photo: move it, give it its own group, or remove it. */
  onMovePhoto: (photo: TrayPhoto) => void;
  /** Removes one photo (its ×): it is gone at once, with a short toast and no Undo. */
  onRemovePhoto: (photo: TrayPhoto) => void;
  /** Asks to remove the whole group (its ⋯): the page asks first. */
  onRemoveGroup: () => void;
  /** The card's Cancel (B137 F1, F1b): closes the sheet and keeps the photo; absent on the Photos page, where Cancel closes the packet card back to its photo (F6). */
  onKeepPhoto?: () => void;
  /**
   * A photo of seed packets: what the packet reader read off it, or 'reading'
   * while it reads; null or absent for a plant question.
   */
  packets?: PacketScan | 'reading' | null;
  /** The packets were filed into a bed (the photo leaves the tray). */
  onPacketsFiled?: (result: PacketResult) => void;
  /** The packets were kept in the Seed vault (B137; the photo leaves the tray). */
  onPacketsKept?: (result: KeepResult) => void;
  /** "Ask about it as a plant" (the ⋯ menu of a seed-packets group): the reader misread it. */
  onNotPackets?: () => void;
  /** Added from Beds' photo row (D78 P2/P4): the bed starts on "A new bed…". */
  newBed?: boolean;
  /**
   * A group from another day Grow thinks is the same plant: its plant's name
   * and its day ("Jun 12"), for "Same butternut as your Jun 12 photos?".
   * Null or absent when there is none.
   */
  sameAs?: { plant: string; day: string } | null;
  /** "Yes, one plant": puts this group with that one. */
  onSameAs?: () => void;
  /** A photo of several kinds of plant: the photo, whose guess holds them; null or absent for a plant question. */
  kinds?: TrayPhoto | null;
  /** Its plants were filed (the photo leaves the tray). */
  onKindsFiled?: (result: PacketResult) => void;
}

/**
 * A plain name as a plant's name starts: its first letter raised ("tomatillo" is Tomatillo).
 *
 * @param text - The name.
 */
const capital = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1);

/**
 * What the Plant list has picked: a plant growing there, "p:<id>"; a new
 * plant of a crop, "c:<crop id>"; the plant Grow does not have that the
 * guess saw, NEW_TO_GROW; or '' while nothing is.
 */
type Pick = string;

/** The pick for a plant Grow does not have, as the guess saw it: a new plant of the gardener's own. */
const NEW_TO_GROW: Pick = 'n:new';

/**
 * A plant growing there, as a pick.
 *
 * @param plant - The plant.
 */
const plantPickOf = (plant: Plant): Pick => `p:${plant.plant_obj_id}`;

/**
 * One group of photos: the pictures, when they were taken, and Location,
 * Plant and Stage with a button that says what it will save.
 *
 * @param props - PileCardProps.
 */
export const PileCard: React.FC<PileCardProps> = ({
  pile, gardenPlants, locations, stages, guessing, busy,
  onAddNew, onAddToExisting, canMove, onMovePhoto, onRemovePhoto, onRemoveGroup, onKeepPhoto,
  packets = null, onPacketsFiled, onPacketsKept, onNotPackets, sameAs = null, onSameAs,
  kinds: kindsPhoto = null, onKindsFiled, newBed = false,
}) => {
  /** The app's words, in the gardener's language. */
  const { reactTranslate: t } = useTranslation();
  // What the group is taken to be (its surest photo's plant, its newest photo's stage), and Grow's pick: the server's.
  const guess = pile.guess;
  /** The server's pick for the pile: what is growing where, what Grow saw, its thoughts. */
  const guessPick = pile.pick;
  /** The Plant list's crops, as the server groups and orders them. */
  const crops = usePickerCrops();
  /** True while the plant kinds are still being fetched. */
  const cropsLoading = crops.isLoading;

  /** The bed the photo was added from, or null. */
  const photosLocation = pile.lead.location_id ?? null;
  /** The chosen bed (null while a new bed is being named). */
  const [locationId, setLocationId] = React.useState<number | null>(newBed && photosLocation === null ? null : photosLocation ?? locations[0]?.id ?? null);
  /** A new bed's name while "A new bed…" is chosen (D78 P4); null for one of theirs. */
  const [newBedName, setNewBedName] = React.useState<string | null>(newBed && photosLocation === null ? '' : null);
  /** Where the plant goes: one of theirs, a new bed by name, or null while neither is said. */
  const bedTarget: number | NewBedRequest | null = newBedName !== null ? (newBedName.trim() ? { newBedName: newBedName.trim() } : null) : locationId;
  /** The server's limits (name lengths). */
  const limits = useGrowLimits();
  /** The chosen stage; starts on Grow's guess. */
  const [stageId, setStageId] = React.useState<number | null>(guess.stage_id ?? null);
  // Once the gardener sets the stage by hand, a change of plant leaves it alone.
  const [stageTouched, setStageTouched] = React.useState(false);
  /** The pick; null until Grow's guess has been applied. */
  const [plantPick, setPlantPick] = React.useState<Pick | null>(null);
  /** A new plant's crop, type and variety. */
  const [choice, setChoice] = React.useState<CropChoice>(EMPTY_CHOICE);
  // Once the gardener picks a plant, or its type or variety, a change in Grow's guess leaves it alone.
  const [pickTouched, setPickTouched] = React.useState(false);
  /** The variety Grow saw is the one chosen in the Variety list (it starts so); false once "Not sure" or another is. */
  const [seenPicked, setSeenPicked] = React.useState(true);
  /** The search box's text. */
  const [query, setQuery] = React.useState('');
  /** True once Add was pressed, so missing fields show. */
  const [tried, setTried] = React.useState(false);
  /** A crop picked starts where the server's types answer says, applied when it arrives (not the gardener's own touch). */
  const starts = usePickStarts(choice, setChoice);
  /** The chosen type's varieties answer: what Variety starts on, and whether it has named ones. */
  const typeVarieties = useTypeVarieties(choice.plantId);
  /** The varieties of the chosen type, once they match it. */
  const varieties = typeVarieties.data && typeVarieties.data.plant.id === choice.plantId ? typeVarieties.data : undefined;

  /** The garden's live plants in the location chosen: the Plant list's first group. */
  const here = React.useMemo(
    () => gardenPlants.filter((plant) => plant.location?.id === locationId),
    [gardenPlants, locationId]
  );
  /** The chosen bed's name, for the button. */
  const locationName = locations.find((location) => location.id === locationId)?.name ?? '';

  /**
   * A new plant of a crop, as it starts: the type Grow guessed and the
   * variety the server says it starts on (the one of the name Grow saw, else
   * its "Not sure") when the crop is the one Grow guessed, else the crop's
   * own start, the server's (its types answer's `start`, applied when it arrives).
   *
   * @param cropId - The crop.
   */
  const choiceForCrop = React.useCallback((cropId: number): CropChoice => (
    guessPick.plantId !== null && guessPick.cropId === cropId
      ? { cropId, plantId: guessPick.plantId, varietyId: guessPick.varietyId }
      : starts.cropPicked(cropId, choice)
  ), [guessPick.plantId, guessPick.cropId, guessPick.varietyId, starts, choice]);

  /**
   * Grow's guess, as a pick in this location: the plant of that type the
   * server says is growing here; else a new one of its crop; a plant Grow
   * does not have as the gardener's own.
   */
  const guessedPick = React.useMemo((): Pick => {
    if (guessPick.plantId === null) return guessPick.newPlant ? NEW_TO_GROW : '';
    const growingHere = locationId === null ? undefined : guessPick.growing[locationId];
    if (growingHere !== undefined && here.some((plant) => plant.plant_obj_id === growingHere)) return `p:${growingHere}`;
    return guessPick.cropId === null ? '' : `c:${guessPick.cropId}`;
  }, [guessPick, locationId, here]);

  /*
   * The guess, applied once it and the crops answer have arrived, again when the
   * location changes, and again when it changes while the gardener has not
   * picked anything themselves: a later group put with this one can bring a
   * surer photo, which then names the group (its type too).
   */
  const appliedGuess = React.useRef<string | null>(null);
  React.useEffect(() => {
    if (guessing || cropsLoading) return;
    const applying = `${guessedPick}|${guess.plant_id ?? guess.new?.name ?? ''}`;
    if (plantPick !== null && (pickTouched || appliedGuess.current === applying)) return;
    appliedGuess.current = applying;
    setPlantPick(guessedPick);
    setChoice(guessedPick.startsWith('c:') ? choiceForCrop(Number(guessedPick.slice(2))) : EMPTY_CHOICE);
    setSeenPicked(true);
  }, [guessing, cropsLoading, plantPick, pickTouched, guessedPick, guess.plant_id, guess.new?.name, choiceForCrop]);
  /*
   * Grow's stage fills in until the gardener sets one, "Not sure yet"
   * included: when it arrives, and when it changes, as it does when a later
   * group is put with this one and its newest photo is now further along.
   */
  const lastGuessedStage = React.useRef<number | null>(null);
  React.useEffect(() => {
    const next = guess.stage_id ?? null;
    if (next === lastGuessedStage.current) return;
    lastGuessedStage.current = next;
    if (!stageTouched && next !== null) setStageId(next);
  }, [guess.stage_id, stageTouched]);

  /** Prefix for the card's field ids. */
  const idBase = `pile-${pile.key}`;
  /** The card was closed with its Cancel on the Photos page (B137 F6, F1b): only the photo shows, and the photo stays. */
  const [cardClosed, setCardClosed] = React.useState(false);
  /**
   * Cancel on any of the card's three parts (seed packets, several kinds, the plant question) keeps the photo and its
   * reading (B137 F1, F1b): in "Check and save" it is the sheet's close (with the toast); on the Photos page it closes the
   * card back to its photo. Removing is the strip's x and the ⋯ menu.
   */
  const keepPhoto = onKeepPhoto ?? ((): void => setCardClosed(true));
  /** The chosen plant answer, or empty. */
  const pick = plantPick ?? '';
  /** True when the pick is a new plant of a kind. */
  const isNew = pick.startsWith('c:');
  // A plant Grow does not have, as the guess saw it: made as the gardener's own when added.
  const newToGrow = pick === NEW_TO_GROW && guess.new ? guess.new : null;
  /** The growing plant picked, or null. */
  const picked = pick.startsWith('p:') ? here.find((plant) => plantPickOf(plant) === pick) ?? null : null;
  /*
   * A variety Grow saw by name, a flower's under its broad parent ("Zinnia")
   * or a plant tag's ("Farao F1"), while the new plant is of the guessed
   * crop. When the type has a variety of that name (theirs or Grow's; the
   * server says which types do), it is in the Variety list already and
   * chosen by id. Otherwise it is offered in the list itself (offerSeen)
   * and, while chosen there, filed as the gardener's own variety of that
   * name (filesSeen). "Not sure", or any other variety, files that instead,
   * so the list and the button agree.
   */
  const seenVariety = isNew && guessPick.seen && choice.plantId !== null && choice.cropId === guessPick.cropId ? guessPick.seen.name : null;
  /** True when the variety Grow saw is not yet one of the type's. */
  const offerSeen = seenVariety !== null && choice.plantId !== null && guessPick.seen?.named[choice.plantId] === undefined;
  /** True when the seen variety is picked and will be filed. */
  const filesSeen = offerSeen && seenPicked && varieties !== undefined && choice.varietyId === varieties.start.varietyId;
  // A variety Grow saw, chosen, answers the Variety question even where the type has no "Not sure".
  const fieldMissing = isNew ? missingField(choice, varieties) : null;
  /** The field still missing, ignoring the variety that the seen name files. */
  const missing = fieldMissing === 'variety' && filesSeen ? null : fieldMissing;
  // The stage is optional, as it is when adding a plant: "Not sure yet" saves the photos without one.
  const complete = bedTarget !== null && pick !== '' && (!isNew || missing === null) && (pick !== NEW_TO_GROW || newToGrow !== null);

  /**
   * Picks a plant: one growing there brings its own stage, so agreeing
   * needs no second look; a new one starts on its crop, and on the stage
   * Grow saw.
   *
   * @param next - The pick.
   */
  const press = (next: Pick): void => {
    setPlantPick(next);
    setPickTouched(true);
    setTried(false);
    if (next.startsWith('c:') || next === NEW_TO_GROW) {
      setChoice(next === NEW_TO_GROW ? EMPTY_CHOICE : choiceForCrop(Number(next.slice(2))));
      // A new plant starts as Grow saw it: on the variety Grow saw, where there is one.
      setSeenPicked(true);
      if (!stageTouched) setStageId(guess.stage_id ?? null);
      return;
    }
    setChoice(EMPTY_CHOICE);
    if (next.startsWith('p:') && !stageTouched) {
      /**
       * Whether a plant growing here is the one picked.
       *
       * @param plant - A plant in the bed.
       */
      const isPicked = (plant: Plant): boolean => plantPickOf(plant) === next;
      // Its stage now, as the server sends it (W24 Job F); the tray works none out.
      const current = here.find(isPicked)?.stage?.id ?? null;
      setStageId(current ?? guess.stage_id ?? null);
    }
  };

  /**
   * Saves the pile as the card says. Every field still needing an answer is
   * marked and the first one takes the focus, so the button never stops
   * without a word.
   */
  const add = (): void => {
    setTried(true);
    if (!complete) {
      const first = bedTarget === null ? (newBedName !== null ? 'location-name' : 'location')
        : pick === '' ? 'plant'
          : missing ? `new-${missing}` : null;
      if (first) document.getElementById(`${idBase}-${first}`)?.focus();
      return;
    }
    if (newToGrow) {
      onAddNew({ name: newToGrow.name, likePlantId: newToGrow.likePlantId }, null, bedTarget as number | NewBedRequest, stageId, null);
    } else if (isNew) {
      // A pile on Type "Not sure" (B52) is the crop and the flag; the server files the crop's usual type.
      const plant = choice.typeUnsure && choice.cropId !== null ? { cropId: choice.cropId, typeUnsure: true as const } : Number(choice.plantId);
      onAddNew(plant, filesSeen ? null : choice.varietyId, bedTarget as number | NewBedRequest, stageId, filesSeen ? seenVariety : null);
    }
    else onAddToExisting(Number(pick.slice(2)), stageId);
  };

  /**
   * A plant growing there, as the server titles it (services/grow/plantNaming:
   * its name, then what tells it from another of the same name, the day it
   * was added for two in one bed, never a counter; audit A36). The bed is
   * left out: the list is that bed's already.
   *
   * @param plant - A plant growing there.
   */
  const labelOf = (plant: Plant): string => plantTitle(plant, { bedShown: true }).map((part) => part.text).join('');

  /*
   * The list, narrowed by the search: the server says which plants growing
   * there and which crops answer what is typed (B121: plantObjIds, cropIds).
   * The pick always stays, so the field never loses its value while a search
   * is typed; until the first answer is in, the list is whole.
   */
  const q = query.trim();
  /** The server's search answer for the box. */
  const answer = usePlantSearch(query, newBedName === null ? locationId : null);
  /** The server's answer while something is typed; null for an empty box or before the first answer. */
  const said = q !== '' ? answer.data ?? null : null;
  /** The growing plants the search keeps. */
  const growing = here.filter((plant) => plantPickOf(plant) === pick || said === null || said.plantObjIds.includes(plant.plant_obj_id));
  // The server's groups in its order, without "What you grow" (the card lists the bed's own plants itself).
  const kinds = (crops.data?.groups ?? [])
    .filter((group) => group.kind !== 'mine')
    .map((group) => ({ kind: group.kind, crops: group.crops.filter((crop) => `c:${crop.id}` === pick || said === null || said.cropIds.includes(crop.id)) }))
    .filter((group) => group.crops.length > 0);
  /*
   * What the search finds, listed under its box, as the server sends it: the
   * plants growing there first, then crops, types and varieties as a new
   * plant. A lone match is no longer picked as the gardener types; the list
   * shows it, and Enter or a tap takes it.
   */
  const hits = said?.rows ?? [];
  /** The search hits as the list draws them. */
  const searchOptions: PlantSearchOption[] = hits.map((hit) => ({
    key: hit.key,
    label: hit.own ? `${hit.label} ${t('plants.form.fields.yours')}` : hit.label,
    // A plant growing there says where; the rest say what the server said after them.
    detail: hit.kind === 'plant' ? t('tray.pile.growingIn', { location: locationName }) : hit.detail,
  }));
  /**
   * A search result taken: a plant growing there, or a new one set to that crop, type and variety. Empties the box.
   *
   * @param key - The result's key: p:, c:, t: or v: and an id.
   */
  const chooseResult = (key: string): void => {
    setQuery('');
    if (key.startsWith('p:')) { press(key); return; }
    const hit = hits.find((each) => each.key === key);
    if (!hit || hit.cropId === null) return;
    press(`c:${hit.cropId}`);
    // A crop starts as press sets it (Grow's guessed type, where it is that crop); a type or variety is as the server named it.
    if (hit.kind !== 'crop') setChoice({ cropId: hit.cropId, plantId: hit.plantId, varietyId: hit.varietyId });
    // A variety found is the one chosen, not the one Grow saw.
    if (hit.kind === 'variety') setSeenPicked(false);
  };

  /** What the Add button says. */
  const buttonText = pick === ''
    ? t('tray.pile.addPhotos')
    : isNew || newToGrow
      // Just "Add": the plant's own name (e.g. "Vining Cherry Tomato") was not on the card, so naming it confused.
      ? t('tray.pile.add')
      : t(pile.photos.length === 1 ? 'tray.pile.saveToOne' : 'tray.pile.saveTo', { count: pile.photos.length, plant: picked ? labelOf(picked) : '' });
  /** True while Grow's guess is still the pick. */
  const guessed = pick !== '' && pick === guessedPick && Boolean(guess.plant_id || guess.new);
  /*
   * What Grow thinks it is, said plainly while Grow's guess is still the
   * pick (the server's words for it): a plant Grow does not have (filed as
   * their own, like the plant it grows most like), or a flower under a broad
   * parent (filed as its own variety there). Null for a plant Grow has as itself.
   */
  const thinks = guessed ? guessPick.thinks : null;

  /** The plant question's fields (location, plant, type, variety, stage, Add and Cancel), or the line saying Grow is looking. */
  const plantFields = (
            guessing ? (
              <GrowLoader variant="block" label={t('tray.pile.looking')} className="py-1" />
            ) : (
              <>
                {/* What Grow thinks it is, plainly, with one Yes that adds it as the button below would. */}
                {thinks && <UnknownPlantCard suggestion={thinks} onYes={add} busy={busy} />}
                <label className="block text-xs text-muted-foreground" htmlFor={`${idBase}-location`}>
                  {t('plants.form.location')}
                  <NativeSelect
                    id={`${idBase}-location`}
                    className="mt-1 text-sm text-foreground"
                    value={newBedName !== null ? 'new' : locationId ?? ''}
                    onChange={(event) => {
                      // "A new bed…": nothing grows there yet, so the plant is a new one.
                      setNewBedName(event.target.value === 'new' ? newBedName ?? '' : null);
                      const next = event.target.value && event.target.value !== 'new' ? Number(event.target.value) : null;
                      setLocationId(next);
                      // The list follows the location. A plant not growing there is
                      // let go, and Grow's guess is tried again in the new place.
                      if (pick.startsWith('p:') && !gardenPlants.some((plant) => plant.location?.id === next && plantPickOf(plant) === pick)) {
                        setPlantPick(null);
                        setChoice(EMPTY_CHOICE);
                      }
                    }}
                    disabled={busy}
                    invalid={tried && bedTarget === null && newBedName === null}
                  >
                    {locationId === null && newBedName === null && <option value="">{t('plants.form.pickLocation')}</option>}
                    {locations.map((location) => <option key={location.id} value={location.id}>{location.name}</option>)}
                    <option value="new">{t('packets.newBed')}</option>
                  </NativeSelect>
                </label>
                {newBedName !== null && (
                  <label className="block text-xs text-muted-foreground" htmlFor={`${idBase}-location-name`}>
                    {t('packets.bedName')}
                    <Input id={`${idBase}-location-name`} className="mt-1 text-sm" value={newBedName} onChange={(event) => setNewBedName(event.target.value)} maxLength={limits.LOCATION_NAME_MAX} disabled={busy} />
                  </label>
                )}

                <div>
                  <label className="block text-xs text-muted-foreground" htmlFor={`${idBase}-plant`}>{t('tray.pile.plant')}</label>
                  <PlantSearchField
                    idPrefix={idBase}
                    query={query}
                    onQueryChange={setQuery}
                    options={searchOptions}
                    onChoose={chooseResult}
                    placeholder={t('tray.pile.searchPlants')}
                    disabled={busy || cropsLoading}
                    inputClassName="text-sm"
                    // "Nothing found" only once the server has answered what is in the box; its failure says so instead.
                    empty={answer.error ? <ServerFailureNote error={answer.error} where="plantSearch" /> : answer.current && (
                      <NoPlantFound query={query}>
                        {/* Not in Grow's list: Grow says what it is, and Yes sets the Plant list to it. */}
                        <DescribePlant
                          query={query}
                          idPrefix={`${idBase}-plant`}
                          disabled={busy}
                          onChosen={(chosen) => {
                            setQuery('');
                            if (chosen.cropId === null) return;
                            press(`c:${chosen.cropId}`);
                            setChoice(chosen);
                            setSeenPicked(false);
                          }}
                        />
                      </NoPlantFound>
                    )}
                  />
                  <NativeSelect
                    id={`${idBase}-plant`}
                    className="mt-1.5 text-sm text-foreground"
                    value={pick}
                    onChange={(event) => press(event.target.value)}
                    disabled={busy}
                    invalid={tried && pick === ''}
                  >
                    {pick === '' && (
                      <option value="">{cropsLoading ? t('plants.form.loadingCatalogue') : t('plants.form.fields.choosePlant')}</option>
                    )}
                    {/* A plant Grow does not have, as the guess saw it: first, as Grow's guess is. */}
                    {guess.new && (
                      <optgroup label={t('tray.kinds.newToGrow')}>
                        <option value={NEW_TO_GROW}>{capital(guess.new.name)}</option>
                      </optgroup>
                    )}
                    {growing.length > 0 && (
                      <optgroup label={t('tray.pile.growingIn', { location: locationName })}>
                        {growing.map((plant) => <option key={plant.plant_obj_id} value={plantPickOf(plant)}>{labelOf(plant)}</option>)}
                      </optgroup>
                    )}
                    {kinds.map((group) => (
                      <optgroup key={group.kind} label={t('tray.pile.newOf', { kind: t(`plants.form.kinds.${group.kind}`) })}>
                        {group.crops.map((crop) => <option key={crop.id} value={`c:${crop.id}`}>{crop.name}</option>)}
                      </optgroup>
                    ))}
                  </NativeSelect>
                </div>
                {guessed ? (
                  <p className="-mt-1 text-xs text-muted-foreground">
                    {/* A flower under a broad parent, or a plant Grow does not have, says what Grow saw, not a parent's name. */}
                    {pile.agreeLine
                      ? pile.agreeLine
                      : (guess.variety || newToGrow) && guess.plural
                      ? (guess.confidence !== null
                        ? t('tray.pile.looksLike', { plants: guess.plural, confidence: guess.confidence })
                        : t('tray.pile.looksLikePlain', { plants: guess.plural }))
                      : guess.confidence !== null ? t('tray.pile.ourGuess', { confidence: guess.confidence }) : t('tray.pile.ourGuessPlain')}
                  </p>
                ) : tried && pick === '' ? (
                  <p className="-mt-1 text-sm font-medium text-destructive">{t('tray.pile.missingPlant')}</p>
                ) : null}

                {/* What happens to a plant Grow does not have, said where it is chosen. */}
                {newToGrow && (
                  <p className="-mt-1 text-xs text-muted-foreground">{t('tray.kinds.newPlantNoteOne', { plant: newToGrow.name })}</p>
                )}

                {/* A new plant's Type and Variety, only where they have a choice to offer. */}
                {isNew && (
                  <PlantIdentityFields
                    value={choice}
                    onChange={(next) => { setChoice(next); setPickTouched(true); }}
                    missing={tried ? missing : null}
                    disabled={busy}
                    idPrefix={`${idBase}-new`}
                    showPlant={false}
                    seen={offerSeen && seenVariety ? {
                      // A plant tag's words, or what Grow saw (a flower's name).
                      label: t(guessPick.seen?.fromTag ? 'tray.pile.seenOnTag' : 'tray.pile.seenByGrow', { variety: seenVariety }),
                      chosen: filesSeen,
                      onChoose: (chosen) => { setSeenPicked(chosen); setPickTouched(true); },
                    } : null}
                  />
                )}

                {/* Optional, as when adding a plant: "Not sure yet" saves the photos without a stage. */}
                <label className="block text-xs text-muted-foreground" htmlFor={`${idBase}-stage`}>
                  {t('plants.stage.label')} {t('plants.form.fields.optional')}
                  <NativeSelect
                    id={`${idBase}-stage`}
                    className="mt-1 text-sm text-foreground"
                    value={stageId ?? ''}
                    onChange={(event) => { setStageId(event.target.value ? Number(event.target.value) : null); setStageTouched(true); }}
                    disabled={busy}
                  >
                    <option value="">{t('plants.form.fields.notSureYet')}</option>
                    {stages.map((stage) => <option key={stage.stage_id} value={stage.stage_id}>{stage.name}</option>)}
                  </NativeSelect>
                </label>
                {tried && bedTarget === null && (
                  <p className="-mt-1 text-sm font-medium text-destructive">{t(newBedName !== null ? 'packets.why.bed' : 'plants.form.missing.location')}</p>
                )}
                <AddCancelRow onCancel={keepPhoto} disabled={busy}>
                  <Button className="w-full" size="lg" disabled={busy} onClick={add}>
                    {busy ? <Spinner size={16} color="currentColor" /> : buttonText}
                  </Button>
                </AddCancelRow>
              </>
            )
  );

  return (
    <article className={cn('overflow-hidden rounded-sm border bg-card shadow-sm', busy && 'opacity-70', packets && !guessing && 'md:col-span-2')}>
      {/* A seed packets card takes the whole row on a wider screen: its
          packets' names wrapped word by word in half of it. */}
      <PhotoStrip
        photos={pile.photos}
        busy={busy}
        canMove={canMove}
        looking={guessing || packets === 'reading'}
        onMovePhoto={onMovePhoto}
        onRemovePhoto={onRemovePhoto}
      />

      <div className="space-y-3 px-4 pb-4 pt-2">
        <PileHeader photos={pile.photos} day={pile.day} busy={busy} isPackets={Boolean(packets)} onNotPackets={onNotPackets} onRemoveGroup={onRemoveGroup} />

        {/* One quiet line: the same plant as a group from another day? Left alone, they stay two. */}
        {sameAs && !guessing && !packets && !kindsPhoto && (
          <p className="text-xs text-muted-foreground">
            {t('tray.pile.sameAs', { plant: sameAs.plant, day: sameAs.day })}
            {' · '}
            <button
              type="button"
              onClick={onSameAs}
              disabled={busy}
              className="py-1 font-medium text-foreground underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              {t('tray.pile.sameAsYes')}
            </button>
          </p>
        )}

        {/* Seed packets: the packets read, not the plant question. */}
        {cardClosed && !guessing && packets !== 'reading' ? (
          /* Cancel on the page (B137 F6, F1b): the card is closed back to its photo, nothing removed; one tap brings it back. */
          <Button type="button" variant="outline" size="lg" className="w-full" onClick={() => setCardClosed(false)}>
            {t(packets ? 'tray.pile.packetsShow' : 'tray.pile.cardShow')}
          </Button>
        ) : packets && !guessing ? (
          <PacketPile
            scan={packets === 'reading' ? null : packets}
            locations={locations}
            busy={busy}
            idBase={idBase}
            onFiled={(result) => onPacketsFiled?.(result)}
            onKept={(result) => onPacketsKept?.(result)}
            onCancel={keepPhoto}
            newBed={newBed}
          />
        ) : kindsPhoto && !guessing ? (
          /* Several kinds of plant: a plant for each, not the plant question. */
          <KindsPile
            photo={kindsPhoto}
            locations={locations}
            busy={busy}
            idBase={idBase}
            onFiled={(result) => onKindsFiled?.(result)}
            onCancel={keepPhoto}
            somethingElse={plantFields}
            newBed={newBed}
          />
        ) : (
          <>
            <h3 className="font-semibold font-body">{t('tray.pile.whatIsThis')}</h3>

            {plantFields}
          </>
        )}
      </div>
    </article>
  );
};
